import rest from '@exchange/libs/utils/rest/src';

const URL = '/agreement';

export default function Resource({ base }) {
  const futuresDisclaimerUrl = `${URL}/futures-disclaimer`;
  const termsUrl = (date: string) => `${URL}/terms-${date}`;

  return {
    getFuturesDisclaimer: async (): Promise<{ date: string } | undefined> => {
      try {
        return await rest.request(
          {
            url: futuresDisclaimerUrl,
            base,
          },
          {
            useSubaccount: false,
          },
        );
      } catch (e) {
        if ((e as { status: number }).status === 404) {
          return undefined;
        }

        throw e;
      }
    },
    setFuturesDisclaimer: async (): Promise<void> =>
      rest.request(
        {
          url: futuresDisclaimerUrl,
          base,
          method: 'post',
        },
        {
          useSubaccount: false,
        },
      ),
    getTermsAgreement: async (date: string): Promise<{ date: string } | undefined> => {
      try {
        return await rest.request(
          {
            url: termsUrl(date),
            base,
          },
          {
            useSubaccount: false,
          },
        );
      } catch (e) {
        if ((e as { status: number }).status === 404) {
          return undefined;
        }
        throw e;
      }
    },
    setTermsAgreement: async (date: string): Promise<void> =>
      rest.request(
        {
          url: termsUrl(date),
          base,
          method: 'post',
        },
        {
          useSubaccount: false,
        },
      ),
  };
}
